import TemplatedListViewController from "./templated-list-view-controller";
import {
  buildPharmacyViewString,
  buildPharmacies,
  buildPharmacyStatusMessage
} from "./helpers/pharmacy";
import { clearPreBuiltFields } from "./helpers/template-fields";
import { FIELD_NAMES, VIEW_SELECTOR_TYPES } from "../utils/constants";
import {
  getFieldActionEventStates,
  actionEventsMap
} from "./helpers/action-event-states";

const { map } = VIEW_SELECTOR_TYPES;
const { selectPharmacyError, submit, pharmacyMap } = FIELD_NAMES;

class PharmacyMapTemplatedViewController extends TemplatedListViewController {
  getParams() {
    const selectedPharmacy = this.appData?.pharmacies?.selected;
    return selectedPharmacy
      ? {
          selectedData: { ...selectedPharmacy },
          erx_vendor_id: selectedPharmacy.erx_vendor_id,
          erx_vendor_code: selectedPharmacy.erx_vendor_code,
          pharmacy_view: buildPharmacyViewString(selectedPharmacy)
        }
      : {};
  }

  handleButtonClick(name, text, action, ...[, , eventStates]) {
    const { values, pickPharmacyOnMap } = this.appData;

    if (name === pharmacyMap && values.__viewSelector === map) {
      // marker on map is clicked
      pickPharmacyOnMap(action);
    }
    super.handleButtonClick(name, text, action, null, null, eventStates);
  }

  setFieldsCustomStates = (selected, isMap) => {
    const {
      data: {
        pagination: {
          container_name,
          per_page = this.defaultPharmsNumberPerPage
        }
      }
    } = this.screen;
    const continueBtn = this.getFieldByName(submit);
    const errorMessage = this.getFieldByName(selectPharmacyError);
    const paginationContainer = this.getFieldByName(container_name);

    if (isMap) {
      this.setFieldsVisibilityState(errorMessage, false);
      this.setFieldsVisibilityState(continueBtn, Boolean(selected));
      this.setFieldsVisibilityState(paginationContainer, false);
    } else {
      const showPaginationContainer = this.listItems?.length > per_page;

      this.setFieldsVisibilityState(continueBtn, true);
      this.setFieldsVisibilityState(
        paginationContainer,
        showPaginationContainer
      );

      if (showPaginationContainer) {
        this.setPageNumberForPageTextField();
        this.setPaginationButtonsVisibilityState();
      }

      if (selected) {
        this.updateListFieldsState(selected);
      }
    }

    if (!this.appData.screenInitialized) {
      this.setFieldsDefaultState();
      if (selected) {
        this.updatePageNumberBySelectedPharmacy();
      }
    }
  };

  updateListFieldsState = selected => {
    const selectedTile = this.builtItemsByTemplate.find(
      tile => tile?.text?.erx_vendor_id === selected?.erx_vendor_id
    );

    const onClickEventStates = getFieldActionEventStates(
      selectedTile,
      actionEventsMap.onClick
    );

    if (onClickEventStates?.length) {
      this.updateStates(onClickEventStates, false, [
        ...this.builtItemsByTemplate,
        ...this.screen.fields
      ]);
    }
  };

  updatePageNumberBySelectedPharmacy = () => {
    const {
      pharmacies: { selected },
      setPageNumber
    } = this.appData;
    let { pageNumber } = this.appData;
    pageNumber = this.itemsByPage.findIndex(pageTiles => {
      if (
        pageTiles.some(
          tile => tile?.text?.erx_vendor_id === selected?.erx_vendor_id
        )
      ) {
        return true;
      }
      return false;
    });
    if (this.appData?.pageNumber !== ++pageNumber) {
      setPageNumber({
        pageNumber
      });
    }
  };

  preprocessScreenData() {
    const {
      values: { __viewSelector },
      pharmacies,
      settings
    } = this.appData;
    const { selected } = pharmacies;

    buildPharmacyStatusMessage(this.screen, pharmacies, settings);

    if (__viewSelector) {
      const isMap = __viewSelector === map;

      if (isMap) {
        this.listItems = selected ? [selected] : [];

        if (selected) {
          selected.selectedOnMap = true;
        } else {
          clearPreBuiltFields();
        }
      } else {
        this.listItems = pharmacies.all;
      }

      if (this.listItems?.length) {
        this.builtItemsByTemplate = buildPharmacies(
          this.listItems,
          this.screen,
          isMap,
          isMap ? null : this.listItems[0]
        );
      }

      this.itemsByPage = this.paginateFields(this.builtItemsByTemplate);

      if (selected?.selectedOnMap) {
        this.updatePageNumberBySelectedPharmacy();
      }
      this.saveFieldsDefaultState();
      this.fixFieldsOrder();
      this.setFieldsCustomStates(selected, isMap);
    }
  }
}

export default PharmacyMapTemplatedViewController;
